import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';
import { useLang } from '../contexts/LangContext';
import { ValorizaBrandMark } from './ValorizaBrandMark';

const NAV_ITEMS = [
  { path: '/',             key: 'dashboard',      icon: ChartIcon },
  { path: '/fichajes',     key: 'fichajes',       icon: ClockIcon },
  { path: '/empleados',   key: 'empleados',      icon: UsersIcon },
  { path: '/analisis',    key: 'analisis',       icon: TrendIcon },
  { path: '/anomalias',   key: 'anomalias',      icon: AlertIcon },
  { path: '/contratos',   key: 'contratos',      icon: ContractIcon },
  { path: '/trazabilidad', key: 'trazabilidad',  icon: TraceIcon },
  { path: '/reportes',    key: 'reportes',       icon: ReportIcon },
  { path: '/turnos',      key: 'turnos',         icon: ShiftIcon, requiresCenters: true },
  { path: '/notificaciones', key: 'notificaciones', icon: MailIcon },
  { path: '/sync',        key: 'sincronizacion', icon: SyncIcon },
  { path: '/admin',       key: 'admin',          icon: AdminIcon, adminOnly: true },
  { path: '/config',      key: 'configuracion',  icon: SettingsIcon },
  { path: '/ayuda',       key: 'ayuda',          icon: HelpIcon },
];

function HelpIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
      <line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  );
}

function ChartIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2"/>
      <path d="M3 9h18M9 21V9"/>
    </svg>
  );
}
function AdminIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      <line x1="19" y1="8" x2="19" y2="14"/>
      <line x1="16" y1="11" x2="22" y2="11"/>
    </svg>
  );
}
function ClockIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <polyline points="12 6 12 12 16 14"/>
    </svg>
  );
}
function ShiftIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="16" rx="2"/>
      <path d="M3 10h18"/>
      <path d="M9 4v4M15 4v4"/>
      <circle cx="8" cy="15" r="1.4" fill="currentColor"/>
      <circle cx="16" cy="15" r="1.4" fill="currentColor"/>
    </svg>
  );
}
function UsersIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  );
}
function TrendIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/>
      <polyline points="16 7 22 7 22 13"/>
    </svg>
  );
}
function TraceIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="6" cy="6" r="2.2"/>
      <circle cx="18" cy="18" r="2.2"/>
      <path d="M8 6h6a4 4 0 0 1 4 4v6"/>
      <path d="M6 8v4a4 4 0 0 0 4 4h6"/>
    </svg>
  );
}
function ReportIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="3" width="16" height="18" rx="2"/>
      <path d="M8 8h8M8 12h8M8 16h5"/>
    </svg>
  );
}
function SyncIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 4 23 10 17 10"/>
      <polyline points="1 20 1 14 7 14"/>
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
    </svg>
  );
}
function SettingsIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"/>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
    </svg>
  );
}
function LogoutIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
      <polyline points="16 17 21 12 16 7"/>
      <line x1="21" y1="12" x2="9" y2="12"/>
    </svg>
  );
}

function ContractIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
      <line x1="9" y1="15" x2="15" y2="15"/>
      <line x1="12" y1="12" x2="12" y2="18"/>
    </svg>
  );
}

function AlertIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
      <line x1="12" y1="9" x2="12" y2="13"/>
      <line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  );
}

function MailIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="4" width="20" height="16" rx="2"/>
      <path d="m22 6-9.6 7.2a2 2 0 0 1-2.4 0L2 6"/>
    </svg>
  );
}

export function Sidebar({ collapsed, setCollapsed, syncStatus }) {
  const { user, logout } = useAuth();
  const { t, lang, toggleLang } = useLang();
  const location = useLocation();

  const sidebarWidth = collapsed ? '72px' : '260px';

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <motion.div
      data-testid="app-sidebar"
      animate={{ width: sidebarWidth }}
      transition={{ duration: 0.2, ease: 'easeInOut' }}
      style={{
        background: '#1e293b',
        borderRight: '1px solid #334155',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        flexShrink: 0,
        position: 'relative'
      }}
    >
      {/* Logo and Brand */}
      <div style={{
        borderBottom: '1px solid #334155',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Valoriza Brand Block */}
        <ValorizaBrandMark placement="sidebar" collapsed={collapsed} />
        
        {/* Separator */}
        <div style={{ height: '1px', background: '#334155', margin: collapsed ? '0 8px' : '0 16px' }} />
        
        {/* Status indicator */}
        <div style={{
          padding: collapsed ? '12px' : '12px 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: collapsed ? 'center' : 'flex-start',
          gap: '8px'
        }}>
          <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: syncStatus?.is_running ? '#f97316' : '#22c55e', flexShrink: 0 }} />
          {!collapsed && (
            <span style={{ fontSize: '10px', color: '#64748b', fontFamily: 'IBM Plex Mono' }}>
              {syncStatus?.is_running ? 'Sync...' : 'Online'}
            </span>
          )}
        </div>
        
        {/* Collapse/Expand button */}
        {!collapsed && (
          <button
            data-testid="sidebar-collapse-button"
            onClick={() => setCollapsed(true)}
            style={{ 
              position: 'absolute', 
              top: '16px', 
              right: '12px',
              background: 'none', 
              border: 'none', 
              cursor: 'pointer', 
              color: '#64748b', 
              padding: '4px', 
              borderRadius: '6px',
              zIndex: 10
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="15 18 9 12 15 6"/>
            </svg>
          </button>
        )}
        {collapsed && (
          <button
            data-testid="sidebar-expand-button"
            onClick={() => setCollapsed(false)}
            style={{ 
              background: '#1e293b', 
              border: '1px solid #334155', 
              cursor: 'pointer', 
              color: '#64748b', 
              padding: '4px', 
              borderRadius: '50%', 
              position: 'absolute', 
              bottom: '80px', 
              right: '-12px', 
              width: '24px', 
              height: '24px', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              zIndex: 10
            }}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </button>
        )}
      </div>

      {/* Nav Items */}
      <nav style={{ flex: 1, padding: '12px 8px', display: 'flex', flexDirection: 'column', gap: '2px' }}>
        {NAV_ITEMS.filter(item => {
          if (item.adminOnly && user?.role !== 'admin') return false;
          if (item.requiresCenters && user?.role !== 'admin' && !(user?.allowed_centers || []).length) return false;
          return true;
        }).map(({ path, key, icon: Icon }) => {
          const active = isActive(path);
          return (
            <NavLink
              key={path}
              to={path}
              data-testid={`nav-${key}`}
              title={collapsed ? t(key) : undefined}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: collapsed ? '10px' : '10px 12px',
                borderRadius: '8px',
                justifyContent: collapsed ? 'center' : 'flex-start',
                textDecoration: 'none',
                background: active ? 'rgba(59,130,246,0.12)' : 'transparent',
                border: active ? '1px solid rgba(59,130,246,0.2)' : '1px solid transparent',
                color: active ? '#93c5fd' : '#94a3b8',
                transition: 'background-color 200ms, color 200ms, border-color 200ms'
              }}
              onMouseEnter={e => { if (!active) { e.currentTarget.style.background = 'rgba(148,163,184,0.08)'; e.currentTarget.style.color = '#f1f5f9'; }}}
              onMouseLeave={e => { if (!active) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#94a3b8'; }}}
            >
              <Icon size={18} />
              {!collapsed && (
                <span style={{ fontSize: '14px', fontWeight: active ? 600 : 400, whiteSpace: 'nowrap' }}>
                  {t(key)}
                </span>
              )}
            </NavLink>
          );
        })}
      </nav>

      {/* Bottom: Language + User */}
      <div style={{ padding: '8px', borderTop: '1px solid #334155', display: 'flex', flexDirection: 'column', gap: '4px' }}>
        {/* Language toggle */}
        {!collapsed && (
          <button
            onClick={toggleLang}
            style={{
              display: 'flex', alignItems: 'center', gap: '10px',
              padding: '8px 12px', borderRadius: '8px',
              background: 'none', border: 'none', cursor: 'pointer',
              color: '#64748b', fontSize: '13px', fontFamily: 'IBM Plex Mono',
              transition: 'background-color 200ms'
            }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(148,163,184,0.08)'}
            onMouseLeave={e => e.currentTarget.style.background = 'none'}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="2" y1="12" x2="22" y2="12"/>
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
            </svg>
            {lang === 'es' ? 'Cambiar a English' : 'Switch to Español'}
          </button>
        )}

        {/* User info */}
        {user && (
          <div style={{
            display: 'flex', alignItems: 'center',
            padding: collapsed ? '10px' : '8px 12px',
            gap: '10px',
            justifyContent: collapsed ? 'center' : 'flex-start',
          }}>
            <div style={{
              width: '30px', height: '30px', flexShrink: 0,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #1d4ed8 0%, #6366f1 100%)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: 'white', fontSize: '12px', fontWeight: 700
            }}>
              {(user.name || user.email || '?')[0].toUpperCase()}
            </div>
            {!collapsed && (
              <div style={{ flex: 1, overflow: 'hidden' }}>
                <div style={{ color: '#cbd5e1', fontSize: '13px', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {user.name || user.email}
                </div>
                <div style={{ color: '#475569', fontSize: '11px', fontFamily: 'IBM Plex Mono' }}>{user.role}</div>
              </div>
            )}
          </div>
        )}

        {/* Logout */}
        <button
          onClick={logout}
          title={t('cerrarSesion')}
          style={{
            display: 'flex', alignItems: 'center', gap: '10px',
            padding: collapsed ? '10px' : '8px 12px',
            borderRadius: '8px', justifyContent: collapsed ? 'center' : 'flex-start',
            background: 'none', border: 'none', cursor: 'pointer',
            color: '#64748b', fontSize: '13px',
            transition: 'background-color 200ms, color 200ms'
          }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(239,68,68,0.08)'; e.currentTarget.style.color = '#f87171'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'none'; e.currentTarget.style.color = '#64748b'; }}
        >
          <LogoutIcon size={16} />
          {!collapsed && t('cerrarSesion')}
        </button>
      </div>
    </motion.div>
  );
}
